import React from "react";
import { useIntl } from "react-intl";
import { useOutletContext } from "react-router-dom";
import messages from "./messages.i18n";
import { PeekButton, PeekStack, PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
import { useAuthContext } from "@stores/AuthContext";
import { ANALYTICS_DB_NAME } from "@piiqtechnologies/ui-lib";
export const SwitchUser = () => {
    const intl = useIntl();
    const theme = useTheme();
    const { user } = useAuthContext();
    const { onSwitchUser } = useOutletContext();
    const handleSwitchUser = () => {
        onSwitchUser();
        indexedDB.deleteDatabase(ANALYTICS_DB_NAME);
    };
    return (React.createElement(PeekStack, { direction: "row", alignItems: "center", gap: 0.5 },
        React.createElement(PeekButton, { variant: "contained", color: "secondary", onClick: handleSwitchUser }, intl.formatMessage(messages.switchUser)),
        React.createElement(PeekTypography, { variant: "h3", fontWeight: theme.typography.fontWeightLight }, intl.formatMessage(messages.loggedAs, {
            name: (user === null || user === void 0 ? void 0 : user.name) || "-",
            email: (user === null || user === void 0 ? void 0 : user.email) || "-",
            bold: (value) => (React.createElement(PeekTypography, { variant: "h3", fontWeight: theme.typography.fontWeightMedium, display: "contents" }, value)),
        }))));
};
export default SwitchUser;
